
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expert",
      function () {
        return require("private-next-pages/expert/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expert"])
      });
    }
  